<hb-login-container>
    <div content>
        <p class="text-muted">Role has been successfully updated.</p>
        <button class="btn btn-primary px-4 pull-right" type="button" (click)="router.navigateByUrl('/dashboard');">
            <span>{{label}}</span>
        </button>
    </div>
</hb-login-container>
